export default __webpack_public_path__ + "static/media/opakowania i etykiety.0ca9fb97.jpg";